var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.263,
    height: 14,
    viewBox: "0 0 15.263 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dashboard",
    d: "M15.2,7.63A7.63,7.63,0,0,0,0,8.624a7.553,7.553,0,0,0,2.39,5.539,3.078,3.078,0,0,0,2.133.819h6.21a3.175,3.175,0,0,0,2.231-.909A7.6,7.6,0,0,0,15.2,7.63Zm-3.121,5.532a1.908,1.908,0,0,1-1.342.549H4.523a1.82,1.82,0,0,1-1.26-.471A6.3,6.3,0,0,1,1.272,8.624,6.367,6.367,0,0,1,3.394,3.882,6.283,6.283,0,0,1,7.621,2.265a6.71,6.71,0,0,1,.746.042,6.355,6.355,0,0,1,3.708,10.858ZM4.964,11.348a.636.636,0,1,1-.89.909A5.087,5.087,0,0,1,8.357,3.589a.636.636,0,0,1,.539.72.629.629,0,0,1-.72.539,3.815,3.815,0,0,0-3.211,6.5Zm7.7-3.451a5.133,5.133,0,0,1,.052.727,5.043,5.043,0,0,1-1.531,3.634.637.637,0,0,1-.89-.911A3.8,3.8,0,0,0,11.4,8.079a.636.636,0,1,1,1.26-.182Zm-3.811.4a1.293,1.293,0,1,1-.9-.9l2.4-2.4a.636.636,0,1,1,.9.9Z",
    transform: "translate(0 -0.982)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.573db6c9b23086d7557473610b905dc3.svg";
export { ForwardRef as ReactComponent };